'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { applyLandingLanguage, useLandingLanguage } from '@/hooks/useLandingLanguage';
import { getCadrinoLegalCopy, type LegalPageCopy } from '@/lib/cadrino-landing/cadrino-legal-copy';
import { CadrinoMarketingHeader } from './CadrinoMarketingHeader';
import { CadrinoFooter } from './CadrinoFooter';
import { CadrinoShell, Container, MotionBlock } from './shared';
export function CadrinoLegalPage(t0) {
  const $ = _c(9);
  const {
    page
  } = t0;
  const {
    language
  } = useLandingLanguage();
  const copy = getCadrinoLegalCopy(language)[page];
  let t1;
  let t2;
  if ($[0] !== language) {
    t1 = () => {
      applyLandingLanguage(language);
    };
    t2 = [language];
    $[0] = language;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CadrinoMarketingHeader />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = "mt-10 space-y-8";
  const t5 = copy.sections.map(_temp2);
  let t6;
  if ($[4] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== copy.contactNote) {
    t7 = <p className="mt-10 text-sm text-slate-400">{copy.contactNote}</p>;
    $[6] = copy.contactNote;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CadrinoFooter />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return <CadrinoShell>{t3}<main className="border-b border-white/[0.08] py-12 md:py-16"><Container><MotionBlock><article className="mx-auto max-w-3xl"><h1 className="text-3xl font-semibold tracking-tight text-slate-50 md:text-4xl">{copy.title}</h1><p className="mt-3 text-sm text-cadrino-muted">{copy.lastUpdated}</p><p className="mt-6 text-base leading-relaxed text-slate-300">{copy.intro}</p>{t6}{t7}</article></MotionBlock></Container></main>{t8}</CadrinoShell>;
}
function _temp2(section) {
  return <section key={section.title}><h2 className="text-lg font-semibold text-slate-100">{section.title}</h2><p className="mt-3 text-sm leading-relaxed text-cadrino-muted">{section.body}</p>{section.bullets && section.bullets.length > 0 && <ul className="mt-3 list-inside list-disc space-y-2 text-sm text-cadrino-muted">{section.bullets.map(_temp)}</ul>}</section>;
}
function _temp(item) {
  return <li key={item}>{item}</li>;
}